import React, { useState } from 'react';
import Styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Flex, Box } from '@components/layout/Grid';
import Button from '@components/buttons';
import { LiveEventAccess } from '@gql/generated';

const Wrapper = Styled(Box)`
  border: 1px solid #119EDD;
  border-radius: 4px;
  background-color: #F1FBFF;
`;

const Text = Styled.p`
  color: #243240;
  font-size: 14px;
  margin: 5px 0;
  padding: 0 10px;
`;

const Password = Styled.span<{ length: number }>`
  display: inline-block;
  width: ${({ length }) => length * 8}px;
  color: #243240;
  font-size: 14px;
  font-weight: 400;
`;

const TogglePasscode = Styled.button`
  width: 50px;
  color: #119EDD;
  font-weight: 600;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  outline: none;
`;

const ZoomLink = Styled(Text)`
  text-overflow: ellipsis;
  border-top: 1px solid #E0E0E0;
  padding-top: 10px;
  margin-top: 12px;
  overflow: hidden;

  a {
    color: #119EDD;
    text-decoration: none;
  }
`;

type Props = {
  userAccess: LiveEventAccess;
};

const EventZoomDetails = ({ userAccess }: Props) => {
  const [isPasscodeShown, showPasscode] = useState(false);

  let passcode = userAccess.zoomPassword;

  if (!isPasscodeShown) {
    passcode = Array.from(passcode)
      .map((c, i) => (i < 2 ? c : '•'))
      .join('');
  }

  return (
    <Wrapper px={[20, 20, 30]} py={15} data-testid="EventZoomDetails">
      <Flex
        flexDirection={['column', 'column', 'row']}
        justifyContent={'center'}
      >
        <Flex
          flex={1}
          alignItems="center"
          flexDirection={['column-reverse', 'column-reverse', 'row']}
          mb={[10, 10, 0]}
        >
          <Button
            appearance="dark-blue"
            href={userAccess.zoomLink}
            target="_blank"
            rel="noopener"
          >
            <Trans id="live.event_page.reserved_spot.click_join" />
          </Button>
          <Text>
            <Trans id="live.event_page.reserved_spot.hosted_zoom" />
          </Text>
        </Flex>
        <Flex alignItems="center" justifyContent="center">
          <Text>
            <Trans id="live.event_page.reserved_spot.zoom_code_label" />:{' '}
            <Password length={passcode.length}>{passcode}</Password>
          </Text>
          <TogglePasscode onClick={() => showPasscode(!isPasscodeShown)}>
            {isPasscodeShown ? 'Hide' : 'Show'}
          </TogglePasscode>
        </Flex>
      </Flex>
      <ZoomLink>
        <Trans id="live.event_page.reserved_spot.or_copy_link" />:{' '}
        <a href={userAccess.zoomLink} target="_blank" rel="noopened noreferrer">
          {userAccess.zoomLink}
        </a>
      </ZoomLink>
    </Wrapper>
  );
};

export default EventZoomDetails;
